function getAppIcon(system) {
  let icon = "";
  switch (Number(system)) {
    case 1:
      icon = "iconfont icon-anzhuo";
      break;
    case 2:
      icon = "iconfont icon-ios";
      break;
    case 3:
      icon = "iconfont icon-weixin";
      break;
    case 4:
      icon = "iconfont icon-douyin fs-12";
      break;
    case 5:
      icon = "iconfont icon-chrome";
      break;
    case 6:
      icon = "iconfont icon-hongmeng";
      break;
    default:
      icon = "iconfont icon-anzhuo";
      break;
  }
  return icon;
}

export { getAppIcon };
